// extracted by mini-css-extract-plugin
export default {"origin":"AccountsOrigin_origin__ISI3c","total-origin":"AccountsOrigin_total-origin__veD5a"};